<template>
  <div class="footer">
    <!-- <div class="float-right">بیتا ایده</div> -->
    <div class="text-center">
      <strong> تمام حقوق و امتیاز سایت متعلق به جت بار می باشد </strong>&copy;
      1405 - 1399
    </div>
  </div>
</template>
<script>
export default {};
</script>
